import { createSelector } from 'reselect';

import {
  ASSET_PAGE_ROUTE,
  ASSET_VERSION_PAGE_ROUTE,
  COLLECTION_PAGE_ROUTE,
  FAVOURITES_PAGE_ROUTE,
  SAVED_SEARCH_PAGE_ROUTE,
  SEARCH_PAGE_ROUTE,
  SHARE_ASSET_PAGE_ROUTE,
  SHARE_ASSET_VERSION_PAGE_ROUTE,
  SHARE_COLLECTION_PAGE_ROUTE,
} from '../../constants/routes';
import type { AppState } from '../../store/types';
import selectAssetPanels from './kits/asset/asset';
import { selectGridSearchPanels } from './kits/grid_search/grid_search';
import selectShareAssetPanels from './kits/share_asset/share_asset';
import selectShareCollectionPanels from './kits/share_collection/share_collection';
import type { PanelItem } from './types';

const getPanelsProp = (_state: AppState, panels: PanelItem[] | undefined) =>
  panels;

const getRoute = (
  _state: AppState,
  _panels: PanelItem[] | undefined,
  _dispatch: unknown,
  _entityId: string | undefined,
  _versionId: string | undefined,
  route: string,
) => route;

export const selectAvailablePanels = createSelector(
  selectGridSearchPanels,
  selectShareCollectionPanels,
  selectAssetPanels,
  selectShareAssetPanels,
  getPanelsProp,
  getRoute,
  (
    gridSearchPanels,
    shareCollectionPanels,
    assetPanels,
    shareAssetPanels,
    panelsProp,
    route,
  ) => {
    let panels = panelsProp;

    if (!panels) {
      switch (route) {
        case SEARCH_PAGE_ROUTE:
        case COLLECTION_PAGE_ROUTE:
        case SAVED_SEARCH_PAGE_ROUTE:
        case FAVOURITES_PAGE_ROUTE:
          panels = gridSearchPanels.getAll();
          break;
        case SHARE_COLLECTION_PAGE_ROUTE:
          panels = shareCollectionPanels;
          break;
        case ASSET_PAGE_ROUTE:
        case ASSET_VERSION_PAGE_ROUTE:
          panels = assetPanels;
          break;
        case SHARE_ASSET_PAGE_ROUTE:
        case SHARE_ASSET_VERSION_PAGE_ROUTE:
          panels = shareAssetPanels;
          break;
        default:
          panels = [];
      }
    }

    return panels;
  },
);

const getOpenedPanels = (state: AppState) => state.panels.openedPanels;

const getAvailablePanels = (_state: AppState, availablePanels: PanelItem[]) =>
  availablePanels;

export const selectPanelsWithActive = createSelector(
  getOpenedPanels,
  getAvailablePanels,
  (openedPanels, availablePanels) => {
    return availablePanels.map((panel) => ({
      ...panel,
      active:
        openedPanels[panel.key] !== undefined
          ? Boolean(openedPanels[panel.key])
          : panel.active,
    }));
  },
);
